/* eslint-disable react/jsx-pascal-case */
import { Button, Col, ConfigProvider, Form, Row, Modal } from "antd";
import React, { useEffect, useState } from "react";
// import BillPaymentClassForm from "./BillPaymentClassForm.js";
import BaseAdminModal from '../../../../utility/AdminModal/view/BaseAdminModal.js'
const { ConfigContext } = ConfigProvider


const BillPaymentGradeClassStudentChangeModal = (
    {
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        onFinish = () => {

        },
        classId = null,
        setClassId = ()=>{}
    }
) => {

    const axiosModelanguage = {
        post: "新增",
        patch: "修改"
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    return (
        <>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }
            <BaseAdminModal
                type="post"
                title={`繳費單提醒`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={800}
            >
                <Row>
                    <Col span={24}>
                        {/* <BillPaymentClassForm
                            classId={classId}
                            setClassId={setClassId}
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        /> */}
                    </Col>
                </Row>
            </BaseAdminModal>
        </>

    )
}


export default BillPaymentGradeClassStudentChangeModal;
